/**
 * Imports
*/

// utils
import lang from '../misc/i18n.js';
import InstabergUtils from '../misc/utils.js';

/**
 * WordPress dependencies
*/
const { __, _n, sprintf } = wp.i18n;
const { Component, render, findDOMNode, Fragment } = wp.element;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-View-';



/**
 * React Components
*/
class InstabergView_LoadMore extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoadingMore: false,
    };
  }

  render()
  {
    let { isLoadingMore } = this.state;
    let { showLoadMore } = this.props;

    if ( showLoadMore ) {
      if ( isLoadingMore ) {
        return __('Loading...', localizationName);
      }
      else {
        return (
          <React.Fragment>
            <button
              type="button"
              style={ this.props.pcstyle }
              className={ `${ this.getButtonClassName() }` }
              onClick={ ( e ) => { this.props.onClickLoadMore( e ) } }
            >
              { __('Load more', localizationName) }
            </button>
          </React.Fragment>
        );
      }
    }
    return '';
  }

  getButtonClassName()
  {
    const { layoutType } = this.props;

    let className = '';

    switch (layoutType) {

      case 'demo':
        className = '';
        break;

      case 'grid':
        className = 'classic1-button';
        break;

      case 'masonry':
        className = 'masonry-button';
        break;

      case 'classic':
        className = 'classic-button';
        break;

      case 'listsmall':
      case 'metro1':
        className = 'metro1-button';
        break;

      case 'creative2':
        className = 'creative2-button';
        break;

      case 'creative3':
        className = 'creative3-button';
        break;

      case 'metro2':
        className = 'metro2-button';
        break;
    }

    return `${alias + className}`;
  }
}
export { InstabergView_LoadMore };



// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/gallery-view/loadmore.js